var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal"},[_vm._t("header"),_vm._t("content"),_c('button',{staticClass:"close-button",on:{"click":function($event){return _vm.$emit('close')}}},[_c('img',{staticClass:"svg",attrs:{"src":"img/close.svg"}})])],2),_c('div',{staticClass:"backdrop"})])
}
var staticRenderFns = []

export { render, staticRenderFns }